export const translations = {
  es: {
    hero: {
      title: '7 Pasos para Sanar tu Relación con el Dinero',
      subtitle:
        'Un viaje emocional, energético y práctico hacia una vida financiera expansiva',
      tagline:
        'Da el primer paso hacia una vida más ligera, expansiva y abundante',
      cta: 'Comienza tu transformación',
    },
    notification: {
      recentPurchase: 'Compra Reciente',
      from: 'desde',
      ebook: 'E-book',
    },
    intro: {
      greeting:
        'Querida mujer que sabe que nació para más… pero a veces lo duda:',
      p1: 'Si alguna vez has sentido que eres profundamente espiritual, consciente y trabajadora… pero aún así el dinero siempre se mantiene alejado, esto es para ti.',
      p2: 'No estás rota. Solo estás condicionada.',
      p3: 'Y estás a punto de descubrir la raíz invisible que por años te desconectó de la abundancia que siempre fue tuya.',
      p4: 'Quiero que leas cada línea despacio… como si fuera una conversación íntima entre tu corazón y el mío. Porque lo es.',
    },
    pain: {
      title: 'El dolor que nunca dices, pero siempre sientes',
      p1: 'Puede que nadie lo note, pero hay algo en ti que se encoje cuando aparece el tema del dinero. Incluso si sonríes, si ayudas, si das, si meditas, si sostienes a todos… hay un nudo silencioso que no se suelta.',
      p2: 'Y si te sientes así, no estás sola. Las mujeres sensibles y espirituales viven el dinero de forma distinta… y muchas veces lo sufren en silencio.',
    },
    blocks: {
      sabotage: {
        title: 'El autosabotaje silencioso',
        text: "Llega una oportunidad, un ingreso inesperado, un cliente, un proyecto, un 'sí'… y algo pasa. Un gasto, una mala decisión, un miedo, un bloqueo. Y terminas sintiendo culpa, frustración, vergüenza.",
      },
      guilt: {
        title: 'La culpa heredada',
        text: 'En tu corazón vive una frase tatuada: "En mi familia nada fue fácil." Cargas historias de sacrificio, de supervivencia, de carencia. Y a veces sientes que prosperar demasiado sería traicionar a quienes amas.',
      },
      fear: {
        title: 'El miedo a desbalancearte',
        text: 'Quieres abundancia… pero temes volverte superficial, fría o "materialista". Temes que la gente cambie contigo. Temes perder tu esencia.',
      },
      energetic: {
        title: 'Los bloqueos energéticos que tu mente no entiende',
        text: 'Tu cuerpo reacciona antes que tú: presión en el pecho, vacío en el estómago, evasión, incomodidad para cobrar, miedo a pedir, culpa al recibir.',
      },
      anxiety: {
        title: 'La ansiedad financiera silenciosa',
        text: 'Por fuera funcionas. Por dentro preguntas: "¿Me alcanzará?" "¿Qué estoy haciendo mal?" "¿Por qué otras fluyen y yo no?"',
      },
    },
    pullQuote: 'No estás fallando. Estás cargando demasiado.',
    vision: {
      title: 'Cómo se ve tu vida cuando sanas',
      intro1:
        'Imagina tener una relación con el dinero que no duele. Imagina sentir estabilidad, calma, claridad, libertad interna.',
      intro2: 'Imagina:',
      items: [
        'Hablar de dinero sin tensión.',
        'Cobrar sin vergüenza.',
        'Recibir sin culpa.',
        'Poner límites con seguridad.',
        'Tomar decisiones sin ansiedad.',
        'Dejar de sabotear tus oportunidades.',
        'Ver tu vida fluir: ingresos, ideas, personas, estabilidad.',
        'Sentirte alineada con tu alma y tu prosperidad.',
      ],
      closing:
        'Y lo más hermoso: ser la primera mujer de tu linaje que aprende a prosperar sin sufrir.',
    },
    truth: {
      title:
        'La verdad que libera: no es tu culpa, pero sí tu momento de sanar',
      intro:
        'Todo lo que has intentado hasta ahora no te ha funcionado porque trabaja una sola capa:',
      methods: [
        'afirmaciones',
        'meditaciones',
        'libros financieros',
        'terapia',
        'manifestación superficial',
      ],
      p1: 'Pero tu bloqueo financiero es multidimensional: emocional, energético, psicológico, ancestral y comportamental.',
      p2: 'Por eso nada te transformó por completo.',
    },
    origin: {
      title: 'El origen oculto del problema',
      p1: 'Tu relación con el dinero no está rota. Está condicionada.',
      p2: 'Condicionada por creencias, heridas, memorias, discursos familiares, energías que absorbiste sin darte cuenta y mecanismos de protección que tu sistema nervioso creó para mantenerte "a salvo".',
      p3: 'Tu mente de adulta quiere tener más. Pero tu cuerpo de niña aún le teme al dinero.',
      p4: 'Hasta que no sanes esa raíz, el dinero seguirá entrando y saliendo sin quedarse.',
    },
    solution: {
      title: 'La solución: los 7 pasos integrados',
      intro1:
        'Lo que estás a punto de conocer no es un libro. Es un proceso interno profundo que combina emoción, energía, psicología suave, espiritualidad práctica y acción alineada.',
      intro2: 'Cada paso libera una capa:',
      steps: [
        'Identificas la herida emocional.',
        'Cierras la historia financiera de tu linaje.',
        'Elevas tu autoimagen económica.',
        'Sueltas la culpa que te impide recibir.',
        'Reprogramas tu sistema nervioso para sentirte segura con el dinero.',
        'Alineas tu energía con abundancia real.',
        'Tomas acción coherente que sostiene tu nueva identidad.',
      ],
      closing:
        'Este método funciona donde otros fallan porque no sana una parte de ti… sana todas.',
    },
    story: {
      title: 'Mi historia (que quizá también es la tuya)',
      p1: 'Hubo una etapa en mi vida en la que yo hacía todo "bien": meditaciones, rituales, afirmaciones, journaling, manifestación…',
      p2: 'Pero justo cuando estaba por avanzar, algo dentro de mí colapsaba.',
      p3: 'Un día, después de perder una oportunidad gigante por miedo, lloré como una niña. Me sentí insuficiente, frustrada, pequeña.',
      p4: 'Ahí entendí: no era falta de capacidad. Era una herida emocional heredada.',
      p5: 'Ese día comenzó mi búsqueda. Estudié energía, patrones ancestrales, psicología suave, somática emocional, sanación espiritual… y uní todo en un sistema claro, amoroso y poderoso.',
      p6: 'Este libro nació como un acto de amor para la mujer que fui… y para todas las mujeres nobles que, como tú, merecen prosperar sin culpa.',
    },
    benefits: {
      title: 'Lo que este proceso hará por ti',
      items: [
        'Detendrá tu autosabotaje.',
        'Liberará tu culpa financiera.',
        'Te permitirá cobrar lo que vales.',
        'Activará tu seguridad interna.',
        'Transformará tu energía frente al dinero.',
        'Reprogramará patrones que cargaste sin saber.',
        'Te abrirá puertas que siempre estuvieron ahí, esperando que tú estuvieras lista.',
      ],
    },
    invitation: {
      title: 'Una invitación',
      p1: 'Este no es un manual financiero. Es un renacimiento emocional.',
      p2: 'Una guía íntima para sanar, liberar, reprogramar y transformar tu relación con el dinero desde la raíz.',
      p3: 'Si leíste hasta aquí, ya lo sabes: estás lista.',
      p4: 'Lista para caminar hacia una vida más ligera, estable y expandida. Lista para recibir sin miedo. Lista para sanar lo que por generaciones dolió.',
      p5: 'Y lista para convertirte en la mujer que tu linaje soñó… pero nunca pudo ser.',
    },
    purchase: {
      title: 'Comienza Tu Transformación Hoy',
      price: '$9.97',
      priceLabel: 'USD',
      features: [
        'Acceso inmediato al libro completo',
        'Compatible con todos tus dispositivos',
        'Actualizaciones gratuitas de por vida',
        'Garantía de satisfacción 30 días',
      ],
      button: 'Obtener Ahora',
      secure: 'Pago 100% seguro',
      instant: 'Acceso instantáneo',
    },
    cta: {
      title: 'Da el paso',
      items: [
        'Comienza tu proceso de sanación financiera desde la raíz.',
        'Descubre los 7 pasos que transformarán tu relación con el dinero para siempre.',
        'Activa la versión de ti que se siente segura, estable y abundante.',
        'Rompe el patrón.',
        'Sana la herida.',
        'Expándete.',
      ],
      subtitle: 'Tu nueva relación con el dinero empieza hoy.',
      button: 'Comienza tu transformación',
      closing: 'Yo te acompaño. 💛',
    },
    language: {
      select: 'Select your language',
      es: 'Español Latino',
      en: 'English',
    },
  },
  en: {
    hero: {
      title: '7 Steps to Heal Your Relationship with Money',
      subtitle:
        'An emotional, energetic, and practical journey toward an expansive financial life',
      tagline:
        'Take the first step toward a lighter, more expansive and abundant life',
      cta: 'Begin your transformation',
    },
    notification: {
      recentPurchase: 'Recent Purchase',
      from: 'from',
      ebook: 'E-book',
    },
    intro: {
      greeting:
        'Dear woman who knows she was born for more... but sometimes doubts it:',
      p1: "If you've ever felt that you are deeply spiritual, conscious, and hardworking... but money still seems to stay at arm's length, this is for you.",
      p2: "Because you're not broken. You're just conditioned.",
      p3: "And you're about to discover the invisible root that for years disconnected you from the abundance that was always yours.",
      p4: 'I want you to read each line slowly... as if it were an intimate conversation between your heart and mine. Because it is.',
    },
    pain: {
      title: 'The pain you never say, but always feel',
      p1: "No one may notice, but there's something in you that shrinks when money comes up. Even if you smile, help, give, meditate, support everyone... there's a silent knot that won't release.",
      p2: "And if you feel this way, you're not alone. Sensitive and spiritual women experience money differently... and often suffer in silence.",
    },
    blocks: {
      sabotage: {
        title: 'Silent self-sabotage',
        text: "An opportunity arrives, unexpected income, a client, a project, a 'yes'... and something happens. An expense, a bad decision, a fear, a block. And you end up feeling guilt, frustration, shame.",
      },
      guilt: {
        title: 'Inherited guilt',
        text: "In your heart lives a tattooed phrase: 'Nothing was easy in my family.' You carry stories of sacrifice, survival, scarcity. And sometimes you feel that prospering too much would be betraying those you love.",
      },
      fear: {
        title: 'Fear of becoming unbalanced',
        text: "You want abundance... but you fear becoming superficial, cold, or 'materialistic.' You fear people will change with you. You fear losing your essence.",
      },
      energetic: {
        title: "Energetic blocks your mind doesn't understand",
        text: 'Your body reacts before you do: chest pressure, stomach emptiness, avoidance, discomfort charging, fear of asking, guilt receiving.',
      },
      anxiety: {
        title: 'Silent financial anxiety',
        text: "On the outside you function. Inside you ask: 'Will it be enough?' 'What am I doing wrong?' 'Why do others flow and I don't?'",
      },
    },
    pullQuote: "You're not failing. You're carrying too much.",
    vision: {
      title: 'What your life looks like when you heal',
      intro1:
        "Imagine having a relationship with money that doesn't hurt. Imagine feeling stability, calm, clarity, inner freedom.",
      intro2: 'Imagine:',
      items: [
        'Talking about money without tension.',
        'Charging without shame.',
        'Receiving without guilt.',
        'Setting boundaries with security.',
        'Making decisions without anxiety.',
        'Stopping sabotaging your opportunities.',
        'Seeing your life flow: income, ideas, people, stability.',
        'Feeling aligned with your soul and your prosperity.',
      ],
      closing:
        'And the most beautiful thing: being the first woman in your lineage who learns to prosper without suffering.',
    },
    truth: {
      title:
        "The truth that frees: it's not your fault, but it is your time to heal",
      intro:
        "Everything you've tried so far hasn't worked because it addresses only one layer:",
      methods: [
        'affirmations',
        'meditations',
        'financial books',
        'therapy',
        'superficial manifestation',
      ],
      p1: 'But your financial block is multidimensional: emotional, energetic, psychological, ancestral, and behavioral.',
      p2: "That's why nothing completely transformed you.",
    },
    origin: {
      title: 'The hidden origin of the problem',
      p1: "Your relationship with money isn't broken. It's conditioned.",
      p2: "Conditioned by beliefs, wounds, memories, family narratives, energies you absorbed without realizing, and protection mechanisms your nervous system created to keep you 'safe.'",
      p3: 'Your adult mind wants to have more. But your child body still fears it.',
      p4: 'Until you heal that root, money will keep coming and going without staying.',
    },
    solution: {
      title: 'The solution: 7 integrated steps',
      intro1:
        "What you're about to discover is not a book. It's a deep internal process that combines emotion, energy, gentle psychology, practical spirituality, and aligned action.",
      intro2: 'Each step releases a layer:',
      steps: [
        'You identify the emotional wound.',
        "You close your lineage's financial story.",
        'You elevate your economic self-image.',
        'You release the guilt preventing you from receiving.',
        'You reprogram your nervous system to feel safe with money.',
        'You align your energy with real abundance.',
        'You take coherent action that sustains your new identity.',
      ],
      closing:
        "This method works where others fail because it doesn't heal one part of you... it heals all.",
    },
    story: {
      title: 'My story (which may also be yours)',
      p1: "There was a stage in my life when I did everything 'right': meditations, rituals, affirmations, journaling, manifestation...",
      p2: 'But just when I was about to advance, something inside me collapsed.',
      p3: 'One day, after losing a huge opportunity out of fear, I cried like a child. I felt insufficient, frustrated, small.',
      p4: "That's when I understood: it wasn't lack of capacity. It was an inherited emotional wound.",
      p5: 'That day my search began. I studied energy, ancestral patterns, gentle psychology, emotional somatics, spiritual healing... and united everything into a clear, loving, and powerful system.',
      p6: 'This book was born as an act of love for the woman I was... and for all the noble women who, like you, deserve to prosper without guilt.',
    },
    benefits: {
      title: 'What this process will do for you',
      items: [
        'Stop your self-sabotage.',
        'Release your financial guilt.',
        "Allow you to charge what you're worth.",
        'Activate your inner security.',
        'Transform your energy around money.',
        'Reprogram patterns you carried unknowingly.',
        'Open doors that were always there, waiting for you to be ready.',
      ],
    },
    invitation: {
      title: 'An invitation',
      p1: "This is not a financial manual. It's an emotional rebirth.",
      p2: 'An intimate guide to heal, release, reprogram, and transform your relationship with money from the root.',
      p3: "If you've read this far, you already know: you're ready.",
      p4: 'Ready to walk toward a lighter, more stable, and expanded life. Ready to receive without fear. Ready to heal what hurt for generations.',
      p5: 'And ready to become the woman your lineage dreamed of... but could never be.',
    },
    purchase: {
      title: 'Begin Your Transformation Today',
      price: '$9.97',
      priceLabel: 'USD',
      features: [
        'Immediate access to the complete book',
        'Compatible with all your devices',
        'Free lifetime updates',
        '30-day satisfaction guarantee',
      ],
      button: 'Get It Now',
      secure: '100% secure payment',
      instant: 'Instant access',
    },
    cta: {
      title: 'Take the step',
      items: [
        'Begin your financial healing process from the root.',
        'Discover the 7 steps that will transform your relationship with money forever.',
        'Activate the version of you that feels secure, stable, and abundant.',
        'Break the pattern.',
        'Heal the wound.',
        'Expand.',
      ],
      subtitle: 'Your new relationship with money begins today.',
      button: 'Begin your transformation',
      closing: "I'm with you. 💛",
    },
    language: {
      select: 'Select your language',
      es: 'Español Latino',
      en: 'English',
    },
  },
}

export type Language = 'es' | 'en'
export type TranslationKey = keyof typeof translations.es
